<template>
  <div class="row mb-4">
    <h5 class="mt-2">Line Layout</h5>
    <div class="d-flex justify-content-center">
      <canvas
        id="lineLayoutCanvas"
        class="col-12 mt-0 mb-4"
        :width="canvasWidth"
        :height="canvasHeight"
        :style="`max-width: 1280px; ${coatingBooth.id !== null ? '' : 'display: none;'}`"
      >
      </canvas>
    </div>
    <div
      v-if="coatingBooth.reciprocator_side_bottom"
      class="d-flex justify-content-center"
    >
      <canvas
        id="lineLayoutCanvasBottom"
        class="col-12 mt-0 mb-4"
        :width="canvasWidth"
        :height="canvasHeight"
        :style="`max-width: 1280px; ${coatingBooth.id !== null ? '' : 'display: none;'}`"
      >
      </canvas>
    </div>
  </div>
</template>

<script>
import { nextTick } from "vue";
import axios from "axios";

export default {
  name: "LineLayoutVisualization",
  props: {
    coatingBooth: {
      type: Object,
      default: () => ({}),
    },
    canvasWidth: {
      type: Number,
      default: 700,
    },
    canvasHeight: {
      type: Number,
      default: 300,
    },
  },
  async mounted() {
    await this.showLineLayout();
  },
  methods: {
    async showLineLayout() {
      nextTick(async () => {
        this.$store.state.isLoading = true;
        const lineLayoutCanvas = document.getElementById("lineLayoutCanvas");
        const ctxSide = lineLayoutCanvas.getContext("2d");

        const line_layout_image = await this.generateLineLayoutImage();
        this.fillLineLayoutCanvas(line_layout_image, ctxSide);
        if (this.coatingBooth.reciprocator_side_bottom) {
          const lineLayoutCanvasBottom = document.getElementById("lineLayoutCanvasBottom");
          const ctxBottom = lineLayoutCanvasBottom.getContext("2d");
          const line_layout_image_bottom = await this.generateLineLayoutImageBottom();
          this.fillLineLayoutCanvas(line_layout_image_bottom, ctxBottom);
        }

        this.$store.state.isLoading = false;
      });
    },
    getGunNamesFromReciprocator(reciprocator) {
      return reciprocator.guns ? reciprocator.guns.map((gun) => gun.name) : null;
    },
    async generateLineLayoutImageBottom() {
      try {
        const body = {
          line: this.coatingBooth.reciprocator_side_bottom.id,
          canvas_width: this.canvasWidth,
          canvas_height: this.canvasHeight,
          gun_names_overwrite: this.getGunNamesFromReciprocator(this.coatingBooth.reciprocator_side_bottom),
        };
        let response = await axios.post("/api/v1/fp/generatelinelayoutimage/", body);

        return response.data["layout_image"];
      } catch (error) {
        console.error(error);
      }
    },
    async generateLineLayoutImage() {
      try {
        const body = {
          line: this.coatingBooth.reciprocator_side_A.id,
          canvas_width: this.canvasWidth / 2,
          canvas_height: this.canvasHeight,
          gun_names_overwrite: this.getGunNamesFromReciprocator(this.coatingBooth.reciprocator_side_A),
        };
        let response = await axios.post("/api/v1/fp/generatelinelayoutimage/", body);

        const flatImageA = response.data["layout_image"];

        const bodyB = {
          line: this.coatingBooth.reciprocator_side_B.id,
          canvas_width: this.canvasWidth / 2,
          canvas_height: this.canvasHeight,
          gun_names_overwrite: this.getGunNamesFromReciprocator(this.coatingBooth.reciprocator_side_B),
        };
        response = await axios.post("/api/v1/fp/generatelinelayoutimage/", bodyB);

        const flatImageB = response.data["layout_image"];

        const halfWidth = Math.floor(this.canvasWidth / 2);
        const pixelRowLength = halfWidth * 4;
        const height = this.canvasHeight;

        const imageA2D = [];
        const imageB2D = [];
        for (let row = 0; row < height; row++) {
          const start = row * pixelRowLength;
          const end = start + pixelRowLength;
          imageA2D.push(flatImageA.slice(start, end));
          imageB2D.push(flatImageB.slice(start, end));
        }

        const combinedImage2D = imageA2D.map((row, i) => row.concat(imageB2D[i]));

        return combinedImage2D.flat();
      } catch (error) {
        console.error(error);
      }
    },
    fillLineLayoutCanvas(line_layout_image, ctx) {
      const lineLayoutImageData = new ImageData(
        Uint8ClampedArray.from(line_layout_image.values()),
        this.canvasWidth,
        this.canvasHeight,
      );
      ctx.putImageData(lineLayoutImageData, 0, 0);
    },
  },
};
</script>
